import {MapboxUser} from "../../model/mapbox-user";
import {Action, createReducer, on} from "@ngrx/store";
import {DatacenterV2} from "../../model/datacenter-v2";
import {datacenterActions} from "../actions";
import _ from "lodash";

export interface State {
  changedDatacenters: DatacenterV2[]
}

export const initialState: State = {
  changedDatacenters: []
}

const datacenterReducer = createReducer(initialState,
  on(datacenterActions.datacenterModified, (state, action) => {
    const currentChangedDatacenters: DatacenterV2[] = _.cloneDeep([...state.changedDatacenters]);
    const datacenterModified: DatacenterV2 = _.cloneDeep(action.datacenter);
    if (datacenterModified.auxId) {
      if (!currentChangedDatacenters.some(dc => dc.auxId === datacenterModified.auxId)) {
        currentChangedDatacenters.push(datacenterModified);
      } else {
        if (datacenterModified.toUpdate) {
          const currentIndex = currentChangedDatacenters.findIndex(dc => dc.auxId === datacenterModified.auxId);
          currentChangedDatacenters.splice(currentIndex, 1, datacenterModified);
        }
      }
    } else {
      if (!currentChangedDatacenters.some(dc => dc.id === datacenterModified.id)) {
        currentChangedDatacenters.push(datacenterModified);
      } else {
        const currentIndex = currentChangedDatacenters.findIndex(dc => dc.id === datacenterModified.id);
        currentChangedDatacenters.splice(currentIndex, 1, datacenterModified);
      }
    }
    return {
      ...initialState,
      changedDatacenters: currentChangedDatacenters
    };
  }),
  on(datacenterActions.removeDatacenter, (state, action) => {
    let currentChangedDatacenters: DatacenterV2[] = _.cloneDeep([...state.changedDatacenters]);
    const datacenterModified: DatacenterV2 = _.cloneDeep(action.datacenter);
    if(datacenterModified.auxId){
      currentChangedDatacenters = currentChangedDatacenters.filter(dc => dc.auxId !== datacenterModified.auxId);
    }else{
      if (!currentChangedDatacenters.some(dc => dc.id === datacenterModified.id)) {
        currentChangedDatacenters.push(datacenterModified);
      } else {
        const currentIndex = currentChangedDatacenters.findIndex(dc => dc.id === datacenterModified.id);
        currentChangedDatacenters.splice(currentIndex, 1, datacenterModified);
      }
    }

    return {
      ...state,
      changedDatacenters: currentChangedDatacenters
    };
  }),
  on(datacenterActions.nukeStore, (state, action) => {
    return {
      ...initialState
    };
  }),
);

export function reducer(state: State | undefined, action: Action): any {
  return datacenterReducer(state, action);
}
